import { LeftKomaInfo } from '~/src/domain/entities/schema';

export const leftKomaInfoText = {
  finished: { $t: () => 'はすでに終了しています' },
  // prettier-ignore
  unFinished: { $t: ({ info }: { info: LeftKomaInfo }) => `まで残り${info.leftDayCounts}日/${info.leftKomaCounts}コマ`}
};
